const GetServerParsedName = (name) => {
    return name.replaceAll("<color=", "<span style='color:")  
    .replaceAll(">", "''>")
    .replaceAll("</color''}>", "</span>")
    .replaceAll("b''>", "b>");
};

export {GetServerParsedName};